// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"oc_a bhc_a bhc_x","FilterForm__vgroup":"oc_b bhc_rp"};